module.exports = __webpack_public_path__ + "static/media/fight-team.531982d7.png";